

























































































































  import { ChampFormulaire } from '@/commun/components/champ-formulaire';
  import { StepperNombre } from '@/commun/components/champ-formulaire/stepper-nombre';
  import { Tooltip } from '@/commun/components/champ-formulaire/tooltip';
  import { SectionFormulaireCours } from '@/components/faculte/demandes/formulaires/creation-cours/section-formulaire-cours';
  import { ValidationProvider } from 'vee-validate';

  import Vue from 'vue';

  export default Vue.extend({
    name: 'ChargeTravail',
    components: {
      ChampFormulaire,
      StepperNombre,
      Tooltip,
      ValidationProvider,
    },
    mixins: [SectionFormulaireCours],
    computed: {
      totalHeuresValides(): number {
        return (this.$data.demandeCourante.nombreCredits || 0) * 3;
      },
      totalHeures(): number {
        const heures =
          (this.$data.demandeCourante.heuresMagistrales || 0) +
          (this.$data.demandeCourante.heuresTravaux || 0) +
          (this.$data.demandeCourante.heuresPersonnelles || 0);
        return heures;
      },
      messageErreurChargeTravail(): { [key: string]: string } {
        return {
          oneOf: `${this.$t(
            'demande.formulaires.champs.charge-de-travail.erreur-nombre-heure'
          )}`,
        };
      },
    },
  });
